
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import NIcon from '../icons/NIcon.vue';
import { ISelectItem } from './types';
import NTooltip from "@/uikit/hint/NTooltip.vue";

@Options({
  name: 'NSelectItems',
  components: { NTooltip, NIcon }
})
export default class NSelectItems extends Vue {
  @Prop({ type: Array, default: () => [] })
  readonly items!: ISelectItem[];

  @Prop({ type: Boolean, default: false })
  readonly multiple!: false;

  @Prop({ type: String })
  readonly dataQa?: string;

  @Prop({ type: Boolean, default: false })
  readonly capitalizeLabels!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly showTooltip!: boolean;

  selectedItem: HTMLElement | null = null;
  tooltipText: string = '';

  getClasses(item: ISelectItem) {
    return {
      'n-select-items__capitalize': this.capitalizeLabels,
      'n-select-items__item_disabled': item.disabled
    };
  }

  handleClick(item: ISelectItem) {
    if (item.disabled) return;

    if (this.multiple) {
      item.checked = !item.checked;
    }
    this.$emit('select', item);
  }

  displayTooltip(e: Event, item: ISelectItem) {
    this.selectedItem = e.target as HTMLElement;
    this.tooltipText = item.label;
  }

  hideTooltip() {
    this.selectedItem = null;
    this.tooltipText = '';
  }
}
